module.exports = __webpack_public_path__ + "media/assets/images/blog/solar_panels-fc8e296abe6d9c230a7b8d7ca6353106.jpeg";